import { render } from "./ImageBoxTemplate.vue?vue&type=template&id=5ec22d8f&scoped=true"
import script from "./ImageBoxTemplate.vue?vue&type=script&lang=js"
export * from "./ImageBoxTemplate.vue?vue&type=script&lang=js"

import "./ImageBoxTemplate.vue?vue&type=style&index=0&id=5ec22d8f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec22d8f"]])

export default __exports__